import * as React from 'react'

export function Checkbox({ checked, onCheckedChange, id, className = '' }) {
  return (
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(e) => onCheckedChange?.(e.target.checked)}
      className={`h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500 ${className}`}
    />
  );
}